<template lang='pug'>
  div()
    #conlayout(ref='layout')
      //- #toolbar(v-if='getWSStatus')
      //-   a() 介绍
      //-   a() 参数
      //-   a() 360°查看
      //-   a() 下载
        
      #hpanel(style='margin-top:3px; width:100%')
        //- img(src="/image/H2.jpg" style="width:100%;height:100%;object-fit:contain;")
        slider(ref="slider" :options="slideroption")
          slideritem(v-for="(item,index) in someList" :key="index" :style="item.style") 
            div(v-html="item.html")    
          div(slot="loading") loading...
      #toolbar()
        a() 介绍
        a(href="#home") 参数
        a(href="#" @click="show3DView") 360°查看
        a(href="#home") 下载
      #home(ref='home'  )
        template(v-for='item in sec')
          .sec(:style="{background:item.backColor, height:getWSStatus ? item.secHeight+'px' :'100%'}" )
            template(v-if="imgOnRight(item.imgPos)")
              //- .desc()
              //-   img(:src='item.text' :style="item.textStyle") 
              //- .space()
              template(v-if="getWSStatus")
                img(:src='item.text' :style="{maxWidth:'60%'}" ) 
                img(:src='item.img' :style="{ maxWidth:'60%'}")
              template(v-else)
                img(:src='item.text' style="width:90%" ) 
                img(:src='item.img' style="width:90%")
            template(v-else)
              template(v-if="getWSStatus")
                img(:src='item.img' :style="{ maxWidth:'60%'}")
                img(:src='item.text' :style="{maxWidth:'60%'}" ) 
              template(v-else)
                img(:src='item.img' style="width:90%")
                img(:src='item.text' style="width:90%" ) 
              //- .space()
              //- .desc()
              //-   img(:src='item.text' :style="item.textStyle") 
    div(v-if="view3D_show"  style=" position: absolute; left:0px;top:0px;right:0px;bottom:0px;width:100%;height:100%;background-color:#000000CC; z-index:99999; display:flex; justify-content:center; align-items:center;" @click="view3D_show=false")
      iframe(id="view3d" src="image/ET400.XR.html" allowfullscreen  scrolling="no" ref='view3d' )


</template>

<script>
// import { videoPlayer } from "vue-video-player";
// import "video.js/dist/video-js.css";

import { mapGetters } from 'vuex'
// import product from '../../public/data/product.json'
import axios from 'axios'
import { slider, slideritem } from 'vue-concise-slider'

export default {
  name: "home",
  // components: {
  //   videoPlayer
  // },
  data() {
    return {
      lastScrollPos: 0,
      scrollUpdate: false,
      sec:[],//product.home.sec,
      bodyHeight: 0,
      bodyWidth: 0,
      textSize: 12,
      view3D_show:false,
      view3D_style:"",
      someList:      [
        {
        html: '<img src="/image/H1.jpg" style="object-fit:contain; width:100%;"/>',
        style: 'object-fit:contain;'
      },
      {
        html: '<img src="/image/H2.jpg" style="object-fit:contain; width:100%;"/>',
        style: 'object-fit:contain;'
      }
    ],
    slideroption:{
          currentPage: 0,//当前页码
          thresholdDistance: 300,//滑动判定距离
          thresholdTime: 100,//滑动判定时间
          autoplay:5000,//自动滚动[ms]
          loop:true,//循环滚动
          // direction:'vertical',//方向设置，垂直滚动
          loopedSlides:1,//无限滚动前后遍历数
          slidesToScroll:1,//每次滑动项数
          timingFunction: 'ease', // 滑动方式
          speed: 100// 滑动时间
      }
    }
   },
  components: {
    slider,
    slideritem
  },
  methods: {
    show3DView(){
      // console.log("show 3D View");
      this.view3D_show = true;
    },
    onScroll(e) {
      console.log(e);
    },
    pageUpdate() {
      // console.log(this.lastScrollPos);
      for (let item of this.texts)
        if (
          this.lastScrollPos > this.bodyHeight * item.min &&
          this.lastScrollPos < this.bodyHeight * item.max
        ) {
          item.vis = true;
        } else {
          item.vis = false;
        }
    },

    imgOnRight(pos){
      if(pos == 'l') return false;
      else return true;
    },


  },
  computed: {
    ...mapGetters({
	            getWSStatus: 'getWSStatus',
    }),
    // player() {
    //   return this.$refs.videoPlayer.player;
    // },
    // get3DHeight(){
    //   let _w =this.$refs.view3D.clientWidth;
    //   console.log(_w);
    //   if(_w> 600){
    //     return 500;
    //   }
    //   else{
    //     console.log(_w * 0.625 );
    //     return (_w * 0.625 );
    //   }
    // },
    secHeight(){
      let _w = window.screen.availWidth;
      if(_w> 600){
      return (window.screen.availHeight * 0.8 );
      }
      else{
      return (_w * 1.2 );
      }
      // return  750;
    }

  },
  mounted:function(){
      axios({ url: './data/home.json', method: 'get' }).then(res => {
        this.data = []
        if (res.data.sec) {
          this.sec=res.data.sec;
        }
      })
  }
};
</script>
<style lang="less" scoped>
@import "../color";

#conlayout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
#home {
  width: 100%;
  height: 100%;
  background-color: #252525;
  font-size: 0;
  #info {
    width: calc(100% - 20px);
    height: 200px;
    background-color: #252525;
    padding: 10px;
  }
}
#toolbar {
  height: 60px;
  width: calc(100% - 40px);
  background-color: fadeout(@dark_back_color,10%);
  display: flex;
  // position: fixed;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 0 40px 10px 0;
  // z-index: 999999;
  a {
    color: #dfdfdf;
    font-size: 10pt;
    margin-left: 20px;
  }
}
#view3DDialog {
  .el-dialog {
    background: #333!important;
  }
}
@media screen and (min-width: 800px){
  .sec{
    width:100%;
    // height:1000px;
    // background-color: #444;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    // max-height:950px;
    // img{
    //   box-shadow: 0px 0px 15px #000;
    // }

    .desc{
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .space{
      width:1%;
    }
    .sectitle{
      font-size: 24pt;
      // color:#fff;
      margin: 20px 0;
    }
    .secDesc{
      font-size: 12pt;
      line-height: 35px;
      // color:#fff;

    }
  }
  #view3d{
    max-width: 800px;
    width: 800px ;
    height:500px;
  }

}
@media screen and (max-width: 800px){
  .sec{
    width:100%;
    // height:800px;
    // height:768px;
    // background-color: #444;
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;

    .desc{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 10px 0;
    }
    .space{
      height:0%;
    }
    .sectitle{
      font-size: 16pt;
      // color:#fff;
      margin: 20px 0;
    }
    .secDesc{
      font-size: 10pt;
      line-height: 30px;
      // color:#fff;
    }
  }
  #view3d{
    // max-width: 800px !important;
    width: 100% ;
    aspect-ratio: 1/0.625 ;
  }

}
.floatText {
  position: absolute;
  font-size: 30pt;
  color: #fff;
}



/* 可以设置不同的进入和离开动画 */
/* 设置持续时间和动画函数 */
.fade-left-enter-active,
.fade-right-enter-active {
  transition: all 1s ease;
}
.fade-left-leave-active,
.fade-right-leave-active {
  transition: all 1s cubic-bezier(1, 0.5, 0.8, 1);
}
.fade-left-enter, .fade-left-leave-to 
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(-50px);
  opacity: 0;
}
.fade-right-enter, .fade-right-leave-to 
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(50px);
  opacity: 0;
}

.el-dialog__wrapper{
  background-color: #00000088;
 }

.view3D {
    background: #333!important;
    max-width: 800px !important;
    min-width: 100px !important;
    width: 800px !important;
}
</style>

